import React from "react";
import styles from "./Education.module.css";

import { FaCalendar } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";

import UBBLogo from "../../../../../Assets/Images/Logos/UBB.jpg"

const EducationEntries = [
    {
        firm: "Bábes Bolyai, Databases", 
        logo: UBBLogo,
        title: "Master's degree", 
        date: "2025 - 2027", 
        location: "Cluj-Napoca, Romania",
        content: [
            {
                type: "text", 
                content: ""
            }
        ],
    },
    {
        firm: "Bábes Bolyai, Mathematics and Computer Science ", 
        logo: UBBLogo,
        title: "Bachelor's degree", 
        date: "2022 - 2025", 
        location: "Cluj-Napoca, Romania",
        content: [
            {
                type: "text", 
                content: "My bachelor's thesis: “Unifying the Workflow for MRI Image Analysis and Visualization through an Extensible Web Platform” was graded 10/10 and was awarded by Siemens at an event organized by the university for top theses."
            }
        ],
    }
]

const Education = ({  }) => {
    return (
        <div className={styles.container}>
            <div className={styles.timeline}>
                {EducationEntries.map((entry) => (
                    <div key={`${entry.firm}-${entry.date}`} className={styles.entry}>
                        <div className={styles.entryHeader}>
                            <img src={entry.logo} alt={`${entry.firm} logo`} className={styles.logo} />
                            <div className={styles.headerTexts}>
                                <div className={styles.headerTopRow}>
                                    <p className={styles.firm}>{entry.firm}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.date}>{entry.date}</p>
                                        <FaCalendar className = {styles.icon} />
                                    </div>
                                </div>
                                <div className={styles.headerBottomRow}>
                                    <p className={styles.title}>{entry.title}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.location}>{entry.location}</p>
                                        <FaMapPin className = {styles.icon} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.content}>
                            {entry.content.map((section, idx) => {
                                if (section.type === "text") {
                                    return (
                                        <p key={idx} className={styles.paragraph}>{section.content}</p>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Education;